<template>
    <div class="d-flex justify-content-center flex-wrap py-3">
        <form @submit.prevent="resetPassword" class="col-12 col-sm-4 d-flex flex-wrap bg-white shadow rounded p-5">
            <div class="col-12 text-center mb-4">
                <h3>
                    {{ $t(`Auth.${this.$route.name}.RouteName`) }}
                </h3>
            </div>
            <div class="col-12 form-field mb-4">
                <label for="new_password" class="mb-2">
                    <small :class="{'text-danger' : errors.new_password}">
                        {{ $t('Auth.ResetPassword.new_password') }}
                    </small>
                    <span v-if="errors.new_password" class="text-danger mx-2">
                        -
                    </span>
                    <small v-if="errors.new_password" class="text-danger">
                        {{ errors.new_password }}
                    </small>
                </label>
                <div class="position-relative">
                    <input v-model="new_password" @focus="errors.new_password = null" name="new_password" :type="newPasswordShowed ? 'text' : 'password'" class="form-control" id="new_password" :placeholder="$t('Auth.ResetPassword.insert_new_password')" :class="{'text-danger border-danger' : errors.new_password}">
                    <i class="position-absolute top-50 end-0 translate-middle fa-regular cursor-pointer" @click="newPasswordShowed = !newPasswordShowed" :class="[{'text-danger' : errors.new_password}, newPasswordShowed === true ? 'fa-eye' : 'fa-eye-slash']"></i>
                </div>
            </div>
            <div class="col-12 form-field mb-4">
                <label for="confirm_new_password" class="mb-2">
                    <small :class="{'text-danger' : errors.confirm_new_password}">
                        {{ $t('Auth.ResetPassword.confirm_new_password') }}
                    </small>
                    <span v-if="errors.confirm_new_password" class="text-danger mx-2">
                        -
                    </span>
                    <small v-if="errors.confirm_new_password" class="text-danger">
                        {{ errors.confirm_new_password }}
                    </small>
                </label>
                <div class="position-relative">
                    <input v-model="confirm_new_password" @focus="errors.confirm_new_password = null" name="confirm_new_password" :type="confirmNewPasswordShowed ? 'text' : 'password'" class="form-control" id="confirm_new_password" :placeholder="$t('Auth.ResetPassword.insert_confirm_new_password')" :class="{'text-danger border-danger' : errors.confirm_new_password}">
                    <i class="position-absolute top-50 end-0 translate-middle fa-regular cursor-pointer" @click="confirmNewPasswordShowed = !confirmNewPasswordShowed" :class="[{'text-danger' : errors.confirm_new_password}, confirmNewPasswordShowed === true ? 'fa-eye' : 'fa-eye-slash']"></i>
                </div>
            </div>
            <div class="col-12">
                <button type="submit" class="btn btn-auth btn-auth-second w-100">
                    {{ $t('Auth.ResetPassword.reset_password') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
    name: 'ResetPassword',
    computed: {
        ...mapGetters(['apiPath', 'omsApiKey'])
    },
    data() {
        return {
            new_password: null,
            confirm_new_password: null,
            newPasswordShowed: false,
            confirmNewPasswordShowed: false,
            errors: {}
        }
    },
    methods: {
        ...mapMutations(['setErrorFromServer']),
        resetPassword() {
            this.$http
                .post(`${this.apiPath}/reset_password`, {token: this.$route.query.token, new_password: this.new_password, confirm_new_password: this.confirm_new_password}, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                }).then((res) => {
                    if (res.data.errors) {
                        var errors = res.data.errors
                        for (var i = 0; i < errors.length; i++) {
                            var error = errors[i]
                            if (error.path == 'new_password') {
                                this.errors.new_password = this.$t(`Auth.ResetPassword.errors.new_password.${error.msg}`)
                            }
                            if (error.path == 'confirm_new_password') {
                                this.errors.confirm_new_password = this.$t(`Auth.ResetPassword.errors.confirm_new_password.${error.msg}`)
                            }
                        }
                        this.$toast.error(this.$t('toast.fields_errors'))
                        return
                    }
                    switch (res.data) {
                        case 'Request Expired':
                            this.$toast.error(this.$t('Auth.RequestExpired.expired'))
                            this.$router.replace('/')
                            break
                        default:
                            this.$toast.success(this.$t('Auth.PasswordResetSucceeded.succeeded'))
                            this.$router.replace('/')
                            break
                    }
                }).catch((err) => {
                    this.setErrorFromServer(err.message)
                })
        }
    },
}
</script>